import { Injectable } from "@angular/core"
import { CookieService } from "ngx-cookie-service"
import { buildCookieServiceOptions } from "./cookie.utils"

@Injectable({ providedIn: 'root' })
export class CalendarIntegrationUtil {
  constructor(private cookieService: CookieService) { }

  getCalendar(): string {
    return this.cookieService.get('calendar')
  }

  setCalendar(calendar: string) {
    this.cookieService.set('calendar', calendar, buildCookieServiceOptions(false))
  }
}
